import { IconButton, IconButtonProps, useTheme } from '@mui/material'
import React, { FC } from 'react'

interface StyledIconButtonProps {
  status: 'default' | 'inherit' | 'success' | 'error' | 'warning' | 'info' | 'primary' | 'secondary'
  actionIcon: React.ReactNode
  buttonProps?: IconButtonProps
}

export const StyledIconButton:FC<StyledIconButtonProps> = ({status, actionIcon, buttonProps}) => {
  const theme = useTheme()
  const {sx, ...rest} = buttonProps || {}
  return (
    <IconButton
      component="div"
      size={'small'}
      color={status}
      sx={{
        cursor:'auto',
        borderRadius: (theme.shape.borderRadius as number) / 2,
        backgroundColor: theme.palette[status].light,
        "&:hover": {
          backgroundColor: theme.palette[status].light,
        },
        ...sx
      }}
      {...rest}
    >
      {actionIcon}
    </IconButton>
  )
}